import React, { useState, useEffect } from "react";

const StudentList = ({ onSelectStudent, onStudentsFetched }) => {
  const [classes, setClasses] = useState([]);
  const [studentsByClass, setStudentsByClass] = useState({});

  useEffect(() => {
    // Define mock classes
    const mockClasses = [
      { id: 1, class_name: "Nursery" },
      { id: 2, class_name: "KG" },
      { id: 3, class_name: "Grade 1" },
      { id: 4, class_name: "Grade 2" },
      { id: 5, class_name: "Grade 3" },
    ];
    setClasses(mockClasses);

    // Generate 10 students per class
    const generateFakeStudents = (className, count = 10) =>
      Array.from({ length: count }, (_, i) => ({
        id: `${className}-fake-${i + 1}`,
        studentId: `STU${className.replace(/\s+/g, "").toUpperCase()}${i + 1}`,
        firstName: `John${i + 1}`,
        lastName: `Doe${i + 1}`,
        className,
      }));

    const studentMap = {};
    mockClasses.forEach((cls) => {
      studentMap[cls.class_name] = generateFakeStudents(cls.class_name);
    });

    setStudentsByClass(studentMap);
    onStudentsFetched(Object.values(studentMap).flat());
  }, []);

  return (
    <div className="student-list box fix-height">
      <h2 className="main-heading">Students by Class</h2>
      <div className="classes-grid">
        {classes.map((classItem) => (
          <div key={classItem.id} className="class-column">
            <div className="class-header">
              <h3>{classItem.class_name}</h3>
              <div className="student-count">
                {studentsByClass[classItem.class_name]?.length || 0} Students
              </div>
            </div>
            <ul className="student-items">
              {studentsByClass[classItem.class_name]?.length > 0 ? (
                studentsByClass[classItem.class_name].map((student) => (
                  <li key={student.id} className="student-item">
                    <div className="student-info">
                      <div className="student-name">
                        {student.firstName} {student.lastName}
                      </div>
                      <div className="student-id">{student.studentId}</div>
                    </div>
                    <button
                      className="action-button"
                      onClick={() => onSelectStudent(student)}
                    >
                      View
                    </button>
                  </li>
                ))
              ) : (
                <div className="empty-class">
                  <div className="empty-icon">👥</div>
                  <div className="empty-text">No Students Yet</div>
                  <div className="empty-subtext">
                    Students will appear here when enrolled
                  </div>
                </div>
              )}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentList;
